<template>
  <div class="phased-radar">
    <el-dialog title="相控阵雷达" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body=false ref="prRef"
      :before-close="beforeClose">
      <div class="slider-time">
        <div class="btn-box">
          <img v-show="!isPaly" @click="playAction('play')" src="@/assets/images/播放.png" alt="">
          <img v-show="isPaly" @click="playAction('pause')"  src="@/assets/images/暂停.png" alt="">
        </div>
        <div class="speed-box">
          <span :class="{ active: index <= speedIndex }" @click="speedClick(index)" v-for="index in 5" :key="index" :title="index + 'S'"></span>
        </div>
        <div class="slider-box">
          <div class="point-box">
          <div class="line"></div>
           <div :class="{ 'point-item': true, active: index === sliderIndex }"
                v-for="item, index in times" :key="index"
                @mouseover="mouseover(index)">
            <div class="value" >
              {{ index === sliderIndex ? $moment(item).format('HH:mm') : '0' }}
            </div>
            <div class="point">
              <span ></span>
            </div>
            <div class="time">{{ $moment(item).format('mm') }}</div>
           </div>
          </div>
        </div>
      </div>

      <div class="iamge">
        <img :src="imgUrl" @click="imagePreViewShow=true"  @error="imageError" alt="">
        <!-- <el-image :src="imgUrl" :preview-src-list="[imgUrl]"></el-image> -->
      </div>
    </el-dialog>

    <div class="pre-box" v-show="imagePreViewShow" >
      <img :src="imgUrl"  alt="">
      <i class="el-icon-close image-close" @click = "imagePreViewShow=false"  ></i>
    </div>
  </div>
</template>
<script>
import { apiData } from '../api/index'
export default {
  props: ['params'],
  data () {
    return {
      isShow: true,
      currentIndex: 0,
      isPaly: false,
      sliderIndex: 0,
      speedIndex: 1,
      images: [],
      times: [],
      srcList: [],
      imgUrl: require('@/assets/images/radar.png'),
      timmer: '',
      timmer2: '',
      imagePreViewShow: false
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.setZindex()
          this.timmer2 && clearInterval(this.timmer2)
          this.timmer2 = setInterval(() => {
            this.queryPhasedRadarData()
          }, 5000 * 60)
        } else {
          this.timmer && clearInterval(this.timmer)
        }
      },
      immediate: true
    },
    sliderIndex () {
      this.changeSilderIndex()
    }
  },
  mounted () {
    this.queryPhasedRadarData()
  },
  methods: {
    beforeClose () {
      if (this.params.flag) {
        const index = this.$parent.rightTopData.findIndex(item => item.code === 'A12')
        this.$parent.tabItemClick('right-top', index)
      }
    },

    async queryPhasedRadarData () {
      const result = await apiData.queryPhasedRadarData()
      this.images = result.images.reverse()
      this.times = result.times.reverse()
      this.sliderIndex = this.times.length - 1
    },

    playAction (action) {
      this.isPaly = !this.isPaly
      if (action === 'play') {
        this.timmer = setInterval(() => {
          if (this.sliderIndex < this.times.length - 1) {
            this.sliderIndex++
          } else {
            this.sliderIndex = 0
          }
        }, 1000 * this.speedIndex)
      } else {
        this.timmer && clearInterval(this.timmer)
      }
    },
    speedClick (index) {
      this.timmer && clearInterval(this.timmer)
      this.speedIndex = index
      this.isPaly = false
    },

    changeSilderIndex () {
      this.imgUrl = `${process.env.VUE_APP_DATA}/AESApic/CR/${this.images[this.sliderIndex]}`
      this.srcList = [`${process.env.VUE_APP_DATA}/AESApic/CR/${this.images[this.sliderIndex]}`]
    },

    imageError () {
      this.imgUrl = require('@/assets/images/error.png')
      this.srcList = [require('@/assets/images/error.png')]
    },

    mouseover (index) {
      this.sliderIndex = index
      this.timmer && clearInterval(this.timmer)
      this.isPaly = false
    },

    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.prRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.phased-radar {
  display: flex;
  flex-direction: column;
  pointer-events: none;

.slider-time{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 4vw;
  margin-bottom: 1.04vw;
  box-sizing: border-box;
  .btn-box{
    display: flex;
    align-items: center;
    width: 1.25vw;
    img{
      width: 1.25vw;
      &:hover {
          cursor: pointer;
        }
    }
  }
  .speed-box{
    display: flex;
    align-items: flex-end;
    position: relative;
    top: -0.1vw;
    margin: 0vw 0.58vw;
    span{
      width: 0.21vw;
      height: 0.42vw;
      background: #D8D8D8;
      border-radius: 5.21vw 5.21vw 0vw 0vw;
      margin-right: 0.26vw;
      &:hover{
        cursor: pointer;
      }
    }
    span.active{
      background: #338EFE;
    }
   span:nth-child(2) {
     height: 0.52vw;
   }
   span:nth-child(3) {
     height: 0.73vw;
   }
   span:nth-child(4) {
     height: 0.89vw;
   }
    span:nth-child(5) {
      height: 1.04vw;
    }
  }
  .slider-box{
    flex: 1;
    .point-box{
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      .line{
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50% ,-50%);
         width: 100%;
         border: 0.05vw solid #4D8DFD;
       }
      .point-item{
        flex: 1;
        text-align: center;
        .value{
          color: transparent;
          font-size: 0.73vw;
        }
        .time{
          color: #4D8DFD;
          font-size: 0.73vw;
        }
        .point{
          display: flex;
          justify-content: center;
          span{
            position: relative;
            z-index: 99;
            // top: -0.05vw;
            content: '';
            margin: 0.52vw 0vw;
            width: 0.36vw;
            height: 0.36vw;
            background: #4D8DFD;
            border-radius: 0.21vw;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
      .point-item:hover{
        cursor: pointer;
      }
      .point-item.active{
        color: #EA494D;
        .value{
          color: #EA494D;
        }
        .time {
          color: #EA494D;
        }
        .point{
          span{
            background: #EA494D;
          }
        }
      }
    }
  }
}

.iamge{
  flex: 1;
  overflow: hidden;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
  }
}

  /deep/.el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      width: 46.13rem;
      height: 70vh;
      pointer-events: auto;
    }
  }
}

.pre-box{
  display: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: rgba(0, 0, 0, .5);
  pointer-events: auto;
  .image-close{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 2.08vw;
    right: 2.08vw;
    width: 2.08vw;
    height: 2.08vw;
    font-size: 1.25vw;
    color: #fff;
    border-radius: 100%;
    cursor: pointer;
    background-color: #606266;
  }

}

/deep/ .el-dialog__body{
  overflow: hidden;
  padding: 1vw !important;
}

/deep/ .tabel-cell-last {
  border-top: 1px solid #42506E;
}</style>
